export default __webpack_public_path__ + "media/zurb/img/home/mcafee-img-babc0a4974a2f8bce164caab3c9b8526.jpg";